import { createIconComponent } from '../../factory/create-icon-component';
export const SwissIcon = createIconComponent(
  'SwissIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4605_28279)">
      <path d="M23 5H1V20H23V5Z" fill="#D80027" />
      <path
        d="M16.3047 11.0325H13.4351V8.09766H10.5655V11.0325H7.69595V13.9673H10.5655V16.9022H13.4351V13.9673H16.3047V11.0325Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4605_28279">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
